/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContactDto,
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdatePartnerDto
 */
export interface UpdatePartnerDto {
    /**
     * 
     * @type {number}
     * @memberof UpdatePartnerDto
     */
    id: number;
    /**
     * 
     * @type {Array<ContactDto>}
     * @memberof UpdatePartnerDto
     */
    contacts: Array<ContactDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartnerDto
     */
    comment?: string | null;
}

export function UpdatePartnerDtoFromJSON(json: any): UpdatePartnerDto {
    return UpdatePartnerDtoFromJSONTyped(json, false);
}

export function UpdatePartnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePartnerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contacts': ((json['contacts'] as Array<any>).map(ContactDtoFromJSON)),
        'name': json['name'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function UpdatePartnerDtoToJSON(value?: UpdatePartnerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'contacts': ((value.contacts as Array<any>).map(ContactDtoToJSON)),
        'name': value.name,
        'comment': value.comment,
    };
}


